import { vuexPushArrayToStore } from '../utils/helpers/vuex-push-array-to-store';
import Vue from "vue";

export default {
    setActiveLocale(state, locale) {
        state.activeLocale = locale;
    },
    setDefaultLocale(state, locale) {
        state.defaultLocale = locale;
    },
    pushMapObjects(state, objects) {
        /**
         * We check expire object date
         * if expireDate > now && publishDate < now - we hide object
         */
        const now = Date.now();
        state.objects = objects.filter(object => {
            return ( !object.meta.publish || object.meta.publishDate < now )
            && ( !object.meta.expire || object.meta.expireDate > now )
        });
    },
    pushUnfilteredMapObjects(state, objects) {
        /**
         * unfilteredMapObjects is all map object,
         * after we filter objects item by publishDate and expireDate
         * it needs for terminal
         */
        state.unfilteredMapObjects = objects
    },
    pushCategories(state, listsAndItems) {
        vuexPushArrayToStore(state, 'listsAndItems', listsAndItems)
    },
    setMap(state, map) {
        state.map = map;
    },
    pushMapModels(state, models) {
        vuexPushArrayToStore(state, 'models', models);
    },
    pushMapUnits(state, units) {
        vuexPushArrayToStore(state, 'units', units);
    },
    setAppLoaded(state, value) {
        state.appLoaded = value;
    },
    setTerminalId(state, terminalId) {
        state.terminalId = terminalId;
    },
    setTerminalCode(state, terminalCode) {
        state.terminalCode = terminalCode;
    },
    setLocale(state, newLocale) {
        state.activeLocale = newLocale;
    },
    setMapLoading(state, value) {
        state.mapLoading = value;
    },
    setObjectDistances(state, distances) {
        distances.forEach( d => {
            state.objects.forEach( (o, i, a) => o.unitNames.includes(d.unit) && Vue.set(a[i], 'distance', d.distance) )
        })
    },
    setActivePathToState(state, path) {
        state.activePath = path;
    },
    setActiveStep(state, step, index = null) {
        state.activeStep = step;
    },
    setActiveStepIndex(state, index) {
        state.activeStepIndex = index;
    },
    setActiveMapTheme(state, themeName) {
        state.activeMapTheme = themeName;
    },
    setSessionId (state, sessionId) {
        state.sessionId = sessionId
    },
    setLastModified (state, lastModified) {
        state.lastModified = lastModified
    },
    setCanUpdateMapData (state, canUpdateMapData) {
        state.canUpdateMapData = canUpdateMapData
    },
    setIsMapDataUpdateNeeded (state, isMapDataUpdateNeeded) {
        state.isMapDataUpdateNeeded = isMapDataUpdateNeeded
    },
    setLandscapeMode(state, mode) {
        state.landscape = mode;
    },
    setLastModifiedCheckedAt(state, lastModifiedCheckedAt) {
        state.lastModifiedCheckedAt = lastModifiedCheckedAt
    },
    setMobileGuideStartActivate(state, data) {
        state.isMobileGuideStartActivate = data
    },
    setDataSource(state, dataSourceType){
        state.dataSourceType = dataSourceType
    }
}
